export const truncate = ({ input, size }: { input: string; size: number }) =>
  input?.length > size ? `${input.substring(0, size)} ...` : input
